import React from "react";
import "./Loading.scss";

// import loader from "../../assets/images/Loader5_140.gif"
import loader from "../../assets/images/pil_box_preloader.gif"


function Loading({visible}) {

    return(
        <div>
        {visible?<div className="load-container">
            <div className="preload">
                {/*<img src={mainLogo} alt=""/>*/}
                <img src={loader} alt="" style={{marginTop:20,marginLeft: 50}}/>
            </div>
        </div>:null}
        </div>
    )
}

export default Loading;
